/**
 * @module 易橙会员相关模块路由
 */
export default [
  {
    path: '/member/guarantee',
    name: 'member_guarantee',
    component: () => import('@/pages/activity/member/GuaranteePlan.vue'),
    meta: { title: '保障计划详情', keepAlive: false }
  },
  {
    path: '/member/credit-report/purchase',
    name: 'member_credit_report_purchase',
    component: () => import('@/pages/activity/member/credit-report/purchase'),
    meta: { title: '信用报告', keepAlive: false }
  },
  {
    path: '/member/credit-report/view',
    name: 'member_credit_report_view',
    component: () => import('@/pages/activity/member/credit-report/view'),
    meta: { title: '信用报告', keepAlive: false }
  },
  {
    path: '/member/index',
    name: 'member',
    component: () => import('@/pages/activity/member/index'),
    meta: { title: '开通会员' }
  },
  {
    path: '/member/detail',
    name: 'member_detail',
    component: () => import('@/pages/activity/member/detail'),
    meta: { title: '会员权益详情' }
  },
  {
    path: '/member/order',
    name: 'member_order',
    component: () => import('@/pages/activity/member/order'),
    meta: { title: '提交订单', keepAlive: false }
  },
  {
    path: '/member/address',
    name: 'member_address',
    component: () => import('@/pages/activity/member/address/index'),
    meta: { title: '收货地址管理' }
  },
  {
    path: '/member/addressupdate',
    name: 'member_address_update',
    component: () => import('@/pages/activity/member/address/update'),
    meta: { title: '编辑收货地址' }
  },
  // 收银台（暂未使用）
  // {
  //   path: '/member/pay',
  //   name: 'member_pay',
  //   component: () => import('@/pages/activity/member/pay/index'),
  //   meta: { title: '收银台' }
  // },
  {
    path: '/member/payresult',
    name: 'member_payresult',
    component: () => import('@/pages/activity/member/pay/result'),
    meta: { title: '支付结果' }
  },
  // 主tab页面跳转支付中转页
  {
    path: '/member/payjumppage',
    name: 'member_payjumppage',
    component: () => import('@/pages/activity/member/pay/jumppage'),
    meta: { title: '支付' }
  },
  {
    path: '/member/paywxresult',
    name: 'member_paywxresult',
    component: () => import('@/pages/activity/member/pay/wxresult'),
    meta: { title: '订单支付' }
  },
  {
    path: '/member/orderList',
    name: 'member_orderList',
    component: () => import('@/pages/activity/member/myOrder/index'),
    meta: { title: '我的订单' }
  },
  {
    path: '/member/orderComment',
    name: 'member_orderComment',
    component: () => import('@/pages/activity/member/myOrder/orderComment'),
    meta: { title: '评价订单' }
  },
  {
    path: '/member/orderDetail',
    name: 'member_orderDetail',
    component: () => import('@/pages/activity/member/myOrder/detail'),
    meta: { title: '订单详情' }
  },
  {
    path: '/member/logistics',
    name: 'member_logistics',
    component: () => import('@/pages/activity/member/myOrder/logistics'),
    meta: { title: '物流详情' }
  },
  {
    path: '/member/refund',
    name: 'member_refund',
    component: () => import('@/pages/activity/member/myOrder/refund'),
    meta: { title: '申请退款' }
  },
  {
    path: '/member/refundVirtual',
    name: 'member_refundVirtual',
    component: () => import('@/pages/activity/member/myOrder/refund-virtual'),
    meta: { title: '申请退款' }
  },
  {
    path: '/member/package',
    name: 'member_package',
    component: () => import('@/pages/activity/member/myOrder/package'),
    meta: { title: '我的权益包' }
  },
  {
    path: '/member/refundResult',
    name: 'member_refundResult',
    component: () => import('@/pages/activity/member/myOrder/refund-result'),
    meta: { title: '申请退款' }
  },
  {
    path: '/member/refundLaunch',
    name: 'member_refundLaunch',
    component: () => import('@/pages/activity/member/myOrder/refund/launch'),
    meta: { title: '申请退款' }
  },
  {
    path: '/member/refundInfo',
    name: 'member_refundInfo',
    component: () => import('@/pages/activity/member/myOrder/refund/info'),
    meta: { title: '退款信息填写' }
  },
  {
    path: '/member/refundConfirm',
    name: 'member_refundConfirm',
    component: () => import('@/pages/activity/member/myOrder/refund/confirm'),
    meta: { title: '退款提交' }
  },
  {
    path: '/member/refundComplete',
    name: 'member_refundComplete',
    component: () => import('@/pages/activity/member/myOrder/refund/complete'),
    meta: { title: '退款申请完成' }
  },
  {
    path: '/member/jumpPage',
    name: 'member_jumpPage',
    component: () => import('@/pages/activity/member/myOrder/jumpPage'),
    meta: { title: '京东E卡使用方法' }
  },
  {
    path: '/member/pay/bindcard',
    name: 'member_pay_bindcard',
    component: () => import('@/pages/activity/member/pay/bindbankcard'),
    meta: { title: '添加银行卡', keepAlive: true }
  },
  {
    path: '/member/ocrAdvance',
    name: 'member_ocrAdvance',
    component: () => import('@/pages/activity/member/ocrAdvance/index'),
    meta: { title: '领取额度' }
  },
  {
    path: '/member/ocrAdvance/submit',
    name: 'member_ocrAdvance_submit',
    component: () => import('@/pages/activity/member/ocrAdvance/submit'),
    meta: { title: '领取额度' }
  },
  {
    path: '/member/questionnaire',
    name: 'member_questionnaire',
    component: () => import('@/pages/activity/member/questionnaire/index'),
    meta: { title: '问卷详情' }
  },
  {
    path: '/ycMall/login',
    name: 'ycMall_login',
    component: () => import('@/pages/activity/member/ycMall/login'),
    meta: { title: '登录' }
  },
  {
    path: '/ycMall/index',
    name: 'ycMall_index',
    component: () => import('@/pages/activity/member/ycMall/index'),
    meta: { title: '商城' }
  },
  {
    path: '/ycMall/order',
    name: 'ycMall_order',
    component: () => import('@/pages/activity/member/ycMall/order'),
    meta: { title: '订单提交' }
  },
  {
    path: '/member/fist-enjoy-bindcard',
    name: 'member_fist_enjoy_bindcard',
    component: () => import('@/pages/activity/member/first-enjoy/first-enjoy-bind-card'),
    meta: { title: '专属通道' }
  },
  {
    path: '/member/fist-enjoy-bindcard-byId',
    name: 'member_fist_enjoy_bindcard-byId',
    component: () => import('@/pages/activity/member/first-enjoy/first-enjoy-bind-card-byId'),
    meta: { title: '易橙会员' }
  },
  // 三方渠道使用
  {
    path: '/member/member-benefit-detail',
    name: 'member_benefit_detail',
    component: () => import('@/pages/activity/member/first-enjoy/member-benefit-detail'),
    meta: { title: '查看权益' }
  },
  // 三方渠道使用（花鸭）
  {
    path: '/member/member-user-pay',
    name: 'member_user_pay',
    component: () => import('@/pages/activity/member/first-enjoy/member-user-pay'),
    meta: {
      title: '订单支付',
      keepAlive: true
    }
  },
  {
    path: '/member/auto-pay-manage',
    name: 'auto-pay-manage',
    component: () => import('@/pages/activity/member/auto-pay-manage'),
    meta: { title: '会员管理' }
  }
]
